// extracted by mini-css-extract-plugin
export var fullwidthWrapper = "floating-spheres-layout-module--fullwidth-wrapper--3wrJL";
export var relativeWrapper = "floating-spheres-layout-module--relative-wrapper--1xjCq";
export var animated = "floating-spheres-layout-module--animated--1aiU2";
export var float = "floating-spheres-layout-module--float--2IRJf";